var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2, _path9, _g3, _circle, _circle2, _circle3, _circle4, _circle5, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEncouragingSomeone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 146,
    viewBox: "0 0 288 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111 121C84.4903 121 63 99.5097 63 73C63 46.4903 84.4903 25 111 25C137.51 25 159 46.4903 159 73C159 99.5097 137.51 121 111 121Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 92C107.699 92 88 72.3005 88 48C88 23.6995 107.699 4 132 4C156.301 4 176 23.6995 176 48C176 72.3005 156.301 92 132 92Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127 146C102.699 146 83 126.301 83 102C83 77.6995 102.699 58 127 58C151.301 58 171 77.6995 171 102C171 126.301 151.301 146 127 146Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181 122C156.699 122 137 102.301 137 78C137 53.6995 156.699 34 181 34C205.301 34 225 53.6995 225 78C225 102.301 205.301 122 181 122Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174 79C154.118 79 138 62.8823 138 43C138 23.1177 154.118 7 174 7C193.882 7 210 23.1177 210 43C210 62.8823 193.882 79 174 79Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171 143C155.536 143 143 130.464 143 115C143 99.536 155.536 87 171 87C186.464 87 199 99.536 199 115C199 130.464 186.464 143 171 143Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145 127C173.719 127 197 103.719 197 75C197 46.2812 173.719 23 145 23C116.281 23 93 46.2812 93 75C93 103.719 116.281 127 145 127Z",
    fill: "#EC1D4F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10814_8121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.603 50.338C138.533 47.361 141.29 45.334 144.409 45.334C148.522 45.334 151.783 48.8045 151.526 52.9099L150.833 64.0007L152 96.6673H135.666C134.378 96.6673 133.333 95.6226 133.333 94.334V65.425C133.333 64.4809 133.476 63.5423 133.758 62.6411L137.603 50.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.25 64H163.924C169.349 64 173.267 69.1932 171.776 74.4102L167.593 89.0512C166.305 93.5589 162.185 96.6667 157.497 96.6667H140.917L150.25 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 64,
    width: 14,
    height: 32.6667,
    rx: 2.33333,
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0912 138.909C78.2956 137.754 88.0633 126.113 86.9081 112.909C85.7529 99.7044 74.1121 89.9366 60.9077 91.0919C47.7033 92.2471 37.9355 103.888 39.0908 117.092C40.246 130.297 51.8868 140.064 65.0912 138.909Z",
    fill: "#EC1D4F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10814_8121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6067 103.959C58.9147 102.553 60.1009 101.51 61.5349 101.385C63.4262 101.219 65.0649 102.684 65.112 104.581L65.2395 109.709L67.0899 124.681L59.5801 125.338C58.9876 125.39 58.4653 124.952 58.4134 124.359L57.2506 111.068C57.2126 110.633 57.2407 110.196 57.3339 109.771L58.6067 103.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.971 109.732L71.2577 109.182C73.7523 108.964 75.7623 111.194 75.2869 113.653L73.9525 120.552C73.5416 122.677 71.7723 124.271 69.6168 124.46L61.9937 125.127L64.971 109.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6836,
    y: 111.068,
    width: 6.46154,
    height: 15.0769,
    rx: 1.07692,
    transform: "rotate(-5 49.6836 111.068)",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M247.218 42.8063C258.156 44.3436 268.269 36.7226 269.807 25.7844C271.344 14.8462 263.723 4.73284 252.785 3.19557C241.847 1.65831 231.733 9.27927 230.196 20.2175C228.659 31.1557 236.28 41.269 247.218 42.8063Z",
    fill: "#EC1D4F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10814_8121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.505 13.2087C249.018 12.1246 250.177 11.5001 251.365 11.6671C252.932 11.8873 253.988 13.3836 253.67 14.9335L252.813 19.1206L251.508 31.6249L245.287 30.7506C244.797 30.6816 244.455 30.2278 244.524 29.737L246.071 18.7263C246.122 18.3668 246.226 18.0169 246.382 17.6888L248.505 13.2087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.591 19.0894L257.799 19.8213C259.865 20.1118 261.079 22.2994 260.232 24.2066L257.855 29.5591C257.123 31.207 255.388 32.1701 253.602 31.9192L247.288 31.0317L252.591 19.0894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.926,
    y: 17.3105,
    width: 5.38462,
    height: 12.5641,
    rx: 0.897436,
    transform: "rotate(8 239.926 17.3105)",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 280 138)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 4 43)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 17 129)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 73 3)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 288 68)",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247 88L266 92.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 36.5L29.5 27.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81L16.5 82",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.5 125L230 129",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10814_8121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 51.3333,
    fill: "white",
    transform: "translate(117 45.334)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10814_8121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8462,
    height: 23.6923,
    fill: "white",
    transform: "translate(48.9326 102.486) rotate(-5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10814_8121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5385,
    height: 19.7436,
    fill: "white",
    transform: "translate(240.925 10.2012) rotate(8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncouragingSomeone);
export default __webpack_public_path__ + "static/media/encouraging-someone.016523dc3a826b637ecea487396e4018.svg";
export { ForwardRef as ReactComponent };